import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', name: 'index', component: () => import('./components/Register.vue') },
    // { path: '/home', name: 'Home', component: () => import('./components/Home.vue')  },
    { path: '/home', name: 'Home', component: () => import('./components/Users.vue')  },
    { path: '/main', name: 'My Stations', component: () => import('./components/Main.vue')  },
    { path: '/nested-stations', name: 'Nested Stations', component: () => import('./components/Nested.vue') },
    { path: '/soil-scouts', name: 'Soil Scouts', component: () => import('./components/Soil.vue') },
    { path: '/ids', name: 'ID Config', component: () => import('./components/Ids.vue')  },
    { path: '/qr', name: 'Inventory', component: () => import('./components/QrTags.vue') },
    { path: '/inventory', name: 'Inventory', component: () => import('./components/Inventory.vue') },
    { path: '/manual-records', name: 'Manual Records', component: () => import('./components/ManualRecord.vue') },
    { path: '/lightning-strikes', name: 'Internet Weather',component: () => import('./components/Lightning.vue') },
    { path: '/repairs/:id?/:ticketId?/:ticketStatus?/:sendDate?/:invJobName?/:invNotes?', name: 'Repairs', component: () => import('./components/Repairs.vue')  },
    { path: '/field/:id?', name: 'Field',component: () => import('./components/fieldRepairs.vue')  },
    { path: '/remote/:id?', name: 'Remote',component: () => import('./components/Remote.vue')  },
    { path: '/droplets', name: 'Droplet Manager',component: () => import('./components/Droplets.vue')  },
    { path: '/company', name: 'Campany',component: () => import('./components/Company.vue')  },
    { path: '/users', name: 'Users',component: () => import('./components/Users.vue')  },
    { path: '/lunch', name: 'Lunch',component: () => import('./components/Lunch.vue')  },
    { path: '/mobile', name: 'Mobile Menu',component: () => import('./components/Mobilebar.vue')  }
  ]
})
